import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getOffers, activateOffer, deactivateOffer } from '../actions/OfferActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane, Switch } from 'evergreen-ui';

class ListOffers extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getOffers(opts));
    }

    handleToggleActive = (offerId, currentActive) => {
        const refreshOptions = {
            start: (this.props.page - 1) * this.props.pageSize,
            limit: this.props.pageSize,
            sort: this.props.sort,
            direction: this.props.direction,
            search: this.props.search
        };
        
        if (currentActive) {
            this.props.dispatch(deactivateOffer(offerId, refreshOptions));
        } else {
            this.props.dispatch(activateOffer(offerId, refreshOptions));
        }
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/offers/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Oferta noua
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'name', label: 'Nume'},
                    {
                        id: 'active', 
                        label: 'Activa',  
                        decorator: (item) => {
                            return (
                                <Switch 
                                    checked={item.active} 
                                    onChange={() => this.handleToggleActive(item.id, item.active)}
                                />
                            );
                        }
                    },
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Updated', decorator: 'date'}
                ]}

                data={this.props.data}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}
                
                onTableChange={this.handleTableChange}

                itemMenu={[
                    { getLink: (item) => `/offers/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/offers/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.offers;
}

export default connect(mapStateToProps)(ListOffers);